import LabelInput from "../../../../../shared/components/labelInput";
import { useForm } from "react-hook-form";
import LabelTextArea from "../../../../../shared/components/labelTextArea";
import NewDateTimePicker from "../../../../../shared/components/newDateTimePicker";
import RadioGroup from "../../../../../shared/components/RadioGroup";
import SpCancellationMapper from "../mappers/spCancellationMapper";
import QuoteFormWrapper from "../../../../../shared/components/quoteFormWrapper";
import SupportNavigationButtons from "../../../components/support/SupportNavigationButtons";
import { handleSupportNext } from "../../../utils/supportNavUtils";
import { useNavigate } from "react-router-dom";

const SpCancellation = () => {
  const {
    register,
    watch,
    setValue,
    control,
    trigger,
    formState: { errors, isValid },
    handleSubmit,
  } = useForm({
    defaultValues: SpCancellationMapper.get(),
  });

  const reasonOptions = [
    { value: "stop_driving", label: "Stop Driving" },
    { value: "sold_vehicle", label: "Sold Vehicle" },
    { value: "financial_reasons", label: "Financial Reasons" },
    { value: "other", label: "Other" },
  ];
  const navigate = useNavigate();

  const onSubmit = (data) => {
    SpCancellationMapper.set(data);
    handleSupportNext(navigate);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <QuoteFormWrapper>
        <h1 className="margin-bottom-30">Cancel Policy</h1>

        <NewDateTimePicker
          name="cancellationEffectiveDateTime"
          label="Effective Date and Time"
          errors={errors.cancellationEffectiveDateTime}
          setValue={setValue}
          control={control}
          rules={{ required: "Date is required" }}
          watch={watch}
          defaultValue={watch("cancellationEffectiveDateTime")}
          minDate={new Date()}
        />

        <LabelInput
          id="cancellationReason"
          label="Reason for Cancellation"
          type="select"
          options={reasonOptions}
          control={control}
          errors={errors.cancellationReason}
          placeholder="Select Reason"
          register={register("cancellationReason", {
            required: "Required",
          })}
          watch={watch("cancellationReason")}
          trigger={trigger}
        />
        {watch("cancellationReason")?.value === "other" && (
          <LabelTextArea
            id="otherReason"
            label="Please specify"
            placeholder="Enter details"
            register={register("otherReason", {
              required: "Comments are required",
            })}
            errors={errors.otherReason}
            watch={watch("otherReason")}
            trigger={trigger}
            maxLength={500}
          />
        )}
        <RadioGroup
          name="involved"
          mainLabel="Have you been involved in any accidents/claims since the policy started?"
          register={register}
          errors={errors.involved}
        />
        {watch("involved") === "Yes" && (
          <>
            <NewDateTimePicker
              name="accidentDate"
              label="Date of accident"
              errors={errors.accidentDate}
              setValue={setValue}
              control={control}
              rules={{ required: "Date is required" }}
              watch={watch}
              defaultValue={watch("accidentDate")}
              maxDate={new Date()}
            />
            <RadioGroup
              name="reported"
              mainLabel="Have you reported this to us?"
              register={register}
              errors={errors.reported}
            />
          </>
        )}

        <p className="licPara-12px gray-text margin-top-25">
          <strong>Disclaimer :</strong> Our agent will provide a cancellation
          quote with instruction how to proceed with the cancellation. PLEASE
          NOTE THAT CANCELLATIONS WILL ONLY BE PROCESSED DURING BUSINESS HOURS
          WHICH ARE MONDAY TO FRIDAY 9AM UNTIL 4.00PM. IF A CANCELLATION IS
          REQUESTED OUTSIDE OF BUSINESS HOURS TO TAKE EFFECT IMMEDIATELY IT WILL
          ONLY BE PROCESSED DURING BUSINESS HOURS AND CANCELLATIONS WILL
          NOT BE BACK DATED.
        </p>
      </QuoteFormWrapper>
      <SupportNavigationButtons isValid={isValid} />
    </form>
  );
};

export default SpCancellation;
